import React, { useState } from 'react';
import { DeleteExpenseCategory } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { ExpenseCategoryController } from '../../controllers';

const DeleteExpenseCategoryContainer = ({closeModal, data}) => {
    const [loading, setLoading] = useState(false);
    
    const handleDelete = async (id) => {
        setLoading(true);       
        const { status, errorMessage } = await ExpenseCategoryController.deleteExpenseCategories(id); 
        if (status === constant.Success) {
            ExpenseCategoryController.getExpenseCategories();           
            MimaToastUtil.success({ message: constant.Success })
           setLoading(false);
           return closeModal();
        }  else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }

    const goBack = () => {
        closeModal();
    }
    return (
        <DeleteExpenseCategory
        loading={loading}
        handleDelete={handleDelete}
        closeModal={closeModal}
        goBack={goBack}
        data={data}
        />
    )
}
export default DeleteExpenseCategoryContainer;